import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';

import { RegisterModule } from './Register/register.module';

export function main() {
    enableProdMode();
    return platformBrowserDynamic().bootstrapModule(RegisterModule);
}

if (document.readyState === 'complete') {
    main();
} else {
    document.addEventListener('DOMContentLoaded', main.bind(null));
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./register.boot.ts